import script from "./FinanceLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceLayout.vue?vue&type=script&setup=true&lang=js"

import "./FinanceLayout.vue?vue&type=style&index=0&id=f4fef5dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4fef5dc"]])

export default __exports__